<template>
  <div>
    <SidebarVue ref="sidebar" />
    <Navgator
      ref="navgator"
      :barraTitulo="' Administração - Bancos'"
      :titulo="'bancos'"
    />
    <!--Tabelas-->
    <div class="card-container">
      <div class="card">
        <div class="d-md-none">
          <div v-for="item in bancos" :key="item.nome" class="accordion mb-2">
            <div class="accordion-item">
              <button
                class="accordion-button collapsed card-table-txt"
                data-bs-toggle="collapse"
                :data-bs-target="'#row-' + item.id"
              >
                {{ item.nome }}
              </button>
              <div :id="'row-' + item.id" class="accordion-collapse collapse">
                <div class="accordion-body">
                  <p class="card-table-item">
                    <strong>Código:</strong>
                    {{ item.codigo }}
                  </p>
                  <p class="card-table-item">
                    <strong>Rebate:</strong>
                    {{ item.tacOnRebate_desc }}
                  </p>
                  <p class="card-table-item">
                    <strong>Status:</strong>
                    {{ item.status_desc }}
                  </p>
                  <button
                    type="button"
                    class="btn round-btn align-self-end"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    @click="editar_banco(item)"
                  >
                    <i class="bi bi-pencil-square"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-none d-md-block d-lg-none">
          <div v-for="item in bancos" :key="item.nome" class="accordion mb-2">
            <div class="accordion-item">
              <button
                class="accordion-button collapsed card-table-txt"
                data-bs-toggle="collapse"
                :data-bs-target="'#row-' + item.id"
              >
                {{ item.nome }}
              </button>
              <div :id="'row-' + item.id" class="accordion-collapse collapse">
                <div class="accordion-body">
                  <p class="card-table-item">
                    <strong>Código:</strong>
                    {{ item.codigo }}
                  </p>
                  <p class="card-table-item">
                    <strong>Rebate:</strong>
                    {{ item.tacOnRebate_desc }}
                  </p>
                  <p class="card-table-item">
                    <strong>Status:</strong>
                    {{ item.status_desc }}
                  </p>
                  <button
                    type="button"
                    class="btn btn-modal"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    @click="editar_banco(item)"
                  >
                    <span>Editar</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-none d-lg-block">
          <table class="table border-dark rf_texto">
            <thead>
              <tr>
                <th scope="col" class="rf_header_table">Nome</th>
                <th scope="col" class="rf_header_table">Código</th>
                <th scope="col" class="rf_header_table">Rebate</th>
                <th scope="col" class="rf_header_table">Status</th>
                <th scope="col" class="rf_header_table">Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in bancos" :key="item.id" class="table-linha">
                <td class="rf_header_table">{{ item.nome }}</td>
                <td class="rf_header_table">{{ item.codigo }}</td>
                <td class="rf_header_table">{{ item.tacOnRebate_desc }}</td>
                <td class="rf_header_table">{{ item.status_desc }}</td>
                <td>
                  <button
                    type="button"
                    class="dropdown-toggle-icon"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    @click="editar_banco(item)"
                  >
                    <i class="bi bi-pencil-square"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <pagination
          v-if="bancos.length"
          :offset="totalPages"
          :total="totalItems"
          :limit="pageSize"
          @change-page="handlePageChange"
        />
      </div>
    </div>

    <!-- Modal para edição -->

    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-pencil-square icon-text-logout"></i>
            <span class="txt-title-modal">Editar Banco</span>

            <button
              class="btn-close"
              type="button"
              data-bs-toggle="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body txt-body-modal">
            <div class="row g-2 p-2">
              <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_id"
                    required
                    disabled
                  />
                  <label>Id do Banco</label>
                </div>
              </div>
              <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_nome"
                    required
                  />
                  <label>Nome do Banco</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    v-model="edit_status"
                    required
                  >
                    <option value="0">Desabilitado</option>
                    <option value="1">Habilitado</option>
                  </select>
                  <label>Status</label>
                </div>
              </div>
              <div class="col-12 col-sm-3 col-md-3 col-lg-4 col-xl-4">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    v-model="edit_rebate"
                    required
                  >
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                  <label>Rebate</label>
                </div>
              </div>
              <div class="col-12 col-sm-3 col-md-3 col-lg-4 col-xl-4">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_codigo"
                    required
                  />
                  <label>Código</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-md-none">
              <div class="row">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn round-btn"
                    data-bs-dismiss="modal"
                  >
                    <i class="bi bi-x-circle" title="Cancelar"></i>
                  </button>
                </div>
                <div class="col-6">
                  <button
                    type="button"
                    class="btn round-btn"
                    @click="update()"
                    data-bs-dismiss="modal"
                  >
                    <i class="bi bi-check-circle" title="Confirmar"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="d-none d-md-block">
              <div class="row">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn btn-modal"
                    data-bs-dismiss="modal"
                  >
                    Cancelar
                  </button>
                </div>
                <div class="col-6">
                  <button
                    type="button"
                    class="btn btn-modal"
                    data-bs-dismiss="modal"
                    @click="update()"
                  >
                    Confirmar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Button trigger modal -->
    <div v-if="abrir_modal">
      <Message :msg="msg" v-show="msg" />
    </div>
    <RodapeVue />
  </div>
</template>
<script>
import SidebarVue from "../../components/menu/Sidebar.vue";
import Pagination from "../../components/Pagination.vue";
import userService from "../../services/user.service";
import Message from "../../components/modal/Message.vue";
import RodapeVue from "../../components/menu/Rodape.vue";
import Navgator from "../../components/menu/Navgator.vue";
import axios from "axios";

export default {
  name: "Bancos",
  components: {
    SidebarVue,
    Pagination,
    Navgator,
    Message,
    RodapeVue
  },
  data() {
    return {
      bancos: [],
      msg: "",
      abrir_modal: false,

      id: "",
      nome: "",
      codigo: "",
      status: [
        { text: "Habilitado", value: "1" },
        { text: "Desabilitado", value: "0" }
      ],
      rebate: [
        { text: "Sim", value: "1" },
        { text: "Não", value: "0" }
      ],
      edit_id: "",
      edit_nome: "",
      edit_codigo: "",
      edit_status: "",

      //Params
      searchTitle: "",
      searchStatus: "",
      page: 1,
      totalPages: 0,
      totalItems: 0,
      pageSizes: [5, 10, 15, 35, 50, 100],
      pageSize: 10
    };
  },
  mounted() {
    this.retrieveBancos();
  },
  methods: {
    async onSubmit() {
      await fetch(`${process.env.VUE_APP_API_URL}bancos`, {
        method: "POST",

        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: this.id,
          nome: this.nome,
          tacOnRebate: this.rebate,
          codigo: this.codigo,
          status: this.status
        })
      })
        .then((data) => {
          if (!data.ok) {
            throw Error(data.status);
          }
          return data.json();
        })
        .then((resposta) => {
          console.log(resposta);
          if (resposta.StatusOk == 200) {
            this.abrir_modal = true;
            this.msg = resposta.message;
            setTimeout(() => (this.abrir_modal = false), 4000);
          }
          if (resposta.StatusOk == 204) {
            this.abrir_modal = true;
            this.msg = resposta.message;
            setTimeout(() => (this.abrir_modal = false), 4000);
          }
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.abrir_modal = true;
            this.msg = error.response.data.message;
          }
        });
    },
    //Buscar dados no banco de dados
    getRequestParams(searchTitle, page, pageSize, searchStatus) {
      let params = {};
      if (searchTitle) {
        params["nome"] = searchTitle;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (searchStatus) {
        params["status"] = searchStatus;
      }
      return params;
    },
    handlePageChange(value) {
      this.page = value;
      this.retrieveBancos();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.retrieveBancos();
    },
    async retrieveBancos() {
      try {
        const params = this.getRequestParams(
          this.searchTitle,
          this.page,
          this.pageSize,
          this.searchStatus
        );
        userService.getBancos(params).then((response) => {
          var dados = [];
          var status;
          var rebate;
          const { name, totalPages, totalItems } = response.data;

          this.totalPages = totalPages;
          this.totalItems = totalItems;

          for (var i = 0; i < name.length; i++) {
            if (name[i].status == 0) {
              status = "Desabilitado";
            } else {
              status = "Habilitado";
            }
            if (name[i].tacOnRebate == 0) {
              rebate = "Não";
            } else {
              rebate = "Sim";
            }
            const dados2 = {
              id: name[i].id,
              nome: name[i].nome,
              status_desc: status,
              status_cod: name[i].status,
              codigo: name[i].codigo,
              tacOnRebate_desc: rebate,
              tacOnRebate_cod: name[i].tacOnRebate
            };
            dados.push(dados2);
          }

          this.bancos = dados;
        });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },
    async editar_banco(item) {
      this.edit_id = item.id;
      this.edit_nome = item.nome;
      this.edit_status = item.status_cod;
      this.edit_codigo = item.codigo;
      this.edit_rebate = item.tacOnRebate_cod;
      console.log(item);
    },
    async update() {
      console.log("Estou aqui!");

      try {
        const token = this.$store.state.auth.user.accessToken;

        const headers = {
          "x-access-token": token
        };
        const dados = {
          id: this.edit_id,
          nome: this.edit_nome,
          status: this.edit_status,
          tacOnRebate: this.edit_rebate,
          codigo: this.edit_codigo
        };

        const response = await axios.put(
          `${process.env.VUE_APP_API_URL}bancos/${this.edit_id}`,
          dados,
          { headers }
        );

        if (response.data.StatusOk == 200) {
          this.abrir_modal = true;
          this.msg = response.data.message;
          setTimeout(() => (this.abrir_modal = false), 4000);

          this.retrieveBancos();
        }
      } catch (error) {
        if (error.response.status === 404) {
          console.error("Recurso não encontrado. Verifique o endpoint da API.");
        } else {
          console.error(error);
        }
      }
    }
  }
};
</script>
